// Состояние раздела «Буи» в адресе: выбранные типы, выбранная платформа,
// признак «только свежие», слой раскраски по невязке и границы ИЭЗ.
//
// Умолчания в адрес НЕ пишутся: иначе «Поделиться» отдавал бы длинную ссылку,
// в которой ничего не выбрано, — тот же приём, что у состояния «Моделей».

import { isResidualLayer } from './buoyResidual'

export interface BuoyUrlState {
  types: string[]
  selected: string | null
  hideStale: boolean
  /** Код слоя невязки; `null` — обычная раскраска по свежести. */
  residual: string | null
  /** Показывать ли границы экономических зон. */
  eez: boolean
  /** Промысловые и запретные районы (приказ № 285). */
  fd: boolean
}

export const EMPTY_URL_STATE: BuoyUrlState = {
  types: [], selected: null, hideStale: false, residual: null, eez: false, fd: false,
}

export function parseBuoyUrl(params: URLSearchParams): BuoyUrlState {
  const raw = params.get('types') ?? ''
  const types = raw
    .split(',')
    .map(t => t.trim().toUpperCase())
    .filter(t => t.length > 0)

  const selected = params.get('buoy')
  // Незнакомый слой читается как обычный вид, а не как пустая раскраска:
  // ссылка приходит извне, а карта без единого ореола неотличима от
  // «модель везде точна».
  const residual = params.get('resid')
  return {
    types,
    selected: selected && selected.trim() ? selected.trim() : null,
    hideStale: params.get('fresh') === '1',
    residual: isResidualLayer(residual) ? residual : null,
    // Строгое сравнение, а не «непустая строка»: ссылка приходит извне, а
    // рубежи перекрывают карту линиями, которых человек не просил.
    eez: params.get('eez') === '1',
    fd: params.get('fd') === '1',
  }
}

export function writeBuoyUrl(state: BuoyUrlState): URLSearchParams {
  const params = new URLSearchParams()
  if (state.types.length > 0) params.set('types', state.types.join(','))
  if (state.selected) params.set('buoy', state.selected)
  if (state.hideStale) params.set('fresh', '1')
  if (state.residual) params.set('resid', state.residual)
  if (state.eez) params.set('eez', '1')
  if (state.fd) params.set('fd', '1')
  return params
}
